<template>
  <section v-editable="cms" :class="[name, spacing]">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__grid-image`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 11 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 14, width: 11, reverse: true, order: 1 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.left"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__left`"
          :layout="[{ size: 0, bound: 510, ratio: [510, 680] }]"
        ></component>
      </grid-item>
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__grid-content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 14, width: 11 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 1, width: 11, reverse: true },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.right"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__right`"
          :layout="[{ size: 0, bound: 510, ratio: [510, 510] }]"
        ></component>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-with-image.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-2-column',
    }
  },

  computed: {
    reverse() {
      return this.cms.reverse || false
    },
    fullwidth() {
      return this.cms.fullwidth || false
    },
    spacing() {
      return this.cms.spacing
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::v-deep .m-slide-v2 {
  min-height: initial;
  picture,
  img {
    min-height: initial;
    object-fit: initial;
  }
}

.m-article-2-column {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: transparent;
  padding: 30px 0;

  &__grid {
    align-items: center;
  }

  ::v-deep img,
  ::v-deep picture {
    margin-bottom: 30px;
  }
}

@include media-breakpoint-up(md) {
  .m-article-2-column {
    ::v-deep img,
    ::v-deep picture {
      margin-bottom: initial;
    }
  }
}
</style>
